;(function (global, factory) {
    typeof define === 'function' && define.amd ? define('score_bootstrap/Components/BackToTop',["jquery", "eventManager"], factory) :
    typeof exports === 'object' && typeof module !== typeof void 0 ? module.exports = factory(require("jquery"), require("eventManager")) :
    console && console.error('Back To Top does not support non-amd script loading.');
}(this/* window */, function ($, eventManager) {
    function BackToTop(scope, clickMessagesTransmitting, stateChangeMessages, onShowMessagesPerformer, onHideMessagePerformer, animationDuration, showOnScroll, showOnScrollOffset) {
        ///<summary>Initialize a new instance of Back To Top. Subscribe to messages which are passed to current instance.</summary>

        var self = this;
        
        Object.defineProperties(this, {
            scope: { enumerable: true, value: scope },
            $scope: { enumerable: true, value: $(scope) },
            stateChangeMessages: { enumerable: true, value: stateChangeMessages.slice() }
        });

        BackToTop.prototype.scroll = function () {
            var scrollTop = $(window).scrollTop();
            if (scrollTop > showOnScrollOffset) {
                this.$scope.show();
            } else {
                this.$scope.hide();
            }
        };

        if (showOnScroll) {
            this.scroll();

            $(window).on('scroll', function () {
                self.scroll();
            });
        }
      
        this.$scope.on("click", function (e) { 
            e.preventDefault();
            $('html,body').animate({
                scrollTop: 0
            }, animationDuration);
        });

        //#region click messages transmitting registration
        if (clickMessagesTransmitting.length) {
            this.$scope.on("click", function (e) {
                e.preventDefault();
                clickMessagesTransmitting.forEach(function (ev) {
                    eventManager.trigger(ev, self);
                });

                return !1;
            }).on('keyup', function (e) {
                // catch enter key only
                if (e.keyCode === 13) {
                    e.preventDefault();
                    clickMessagesTransmitting.forEach(function (ev) {
                        eventManager.trigger(ev, self);
                    });

                    return !1;
                }
            });
        }
        //#endregion

        //#region show messages performer
        if (onShowMessagesPerformer.length) {
            onShowMessagesPerformer.forEach(function (messageName) {
                eventManager.subscribe(messageName, self.show, self);
            });

        }
        //#endregion


        //#region hide mesage performer
        if (onHideMessagePerformer.length) {
            onHideMessagePerformer.forEach(function (messageName) {
                eventManager.subscribe(messageName, self.hide, self);
            });
        }
        //#endregion

        this.$scope.on('focus', this._onFocusHandler.bind(this));
        this.$scope.on('blur', this._onBlurHandler.bind(this));
    }

    BackToTop.prototype._onFocusHandler = function (e) {
        $(this).trigger('focus', [this, e]);
    }

    BackToTop.prototype._onBlurHandler = function (e) {
        $(this).trigger('blur', [this, e]);
    }

    BackToTop.prototype.show = function () {
        ///<summary>Make panel visible with jQuery.show() method.</summary>
        this.$scope.show();

        var self = this;
        if (this.stateChangeMessages.length) {
            this.stateChangeMessages.forEach(function (ev) {
                eventManager.trigger(ev, self);
            });
        }
    };

    BackToTop.prototype.hide = function () {
        ///<summary>Make panel hidden with jQuery.hide() method.</summary>
        this.$scope.hide();

        var self = this;
        if (this.stateChangeMessages.length) {
            this.stateChangeMessages.forEach(function (ev) {
                eventManager.trigger(ev, self);
            });
        }
    };

    BackToTop.init = function init(args) {
        if (args.IsEditorEditing) return null;

        var button = new BackToTop(args.scope,
            args.ClickMessagesTransmitting || [],
            args.StateChangeMessagesTransmitting || [],
            args.ShowActionMessages || [],
            args.HideActionMessages || [],
            args.AnimationDuration || 1000,
            args.ShowOnScroll,
            args.ShowOnScrollOffset || 100);

        return button;
    };

    return BackToTop;
}));
